import React, { useMemo } from 'react';
import { RateCardRateBase, Currencies } from '@bringg/types';

import { InputNumber, Select } from '../../../../components';
import { DEFAULT_PRECISION } from '../consts';
import type { RateCardRateBaseOption, RateCartTermUpdater } from '../types';

interface RateCardTermRatePros {
	titleText: string;
	disabled?: boolean;
	rateBase?: RateCardRateBase;
	rateValue?: number;
	rateCurrency?: string;
	rateBaseOptions?: RateCardRateBaseOption[];
	updateTerm?(updater: Partial<RateCartTermUpdater>): void;
	getPopupContainer?(target: HTMLElement): HTMLElement;
}

export const RateCardTermRate = ({
	titleText,
	disabled = false,
	rateBase,
	rateBaseOptions,
	rateValue,
	rateCurrency = 'usd',
	updateTerm,
	getPopupContainer
}: RateCardTermRatePros) => {
	const [onRateBaseChange, onRateValueChange] = useMemo(
		() =>
			updateTerm
				? [
						(rate_base: RateCardRateBase) => updateTerm({ rate_base }),
						(rate_amount: number) => updateTerm({ rate_amount })
				  ]
				: [],
		[updateTerm]
	);

	const currencySign = Currencies[String(rateCurrency).toUpperCase()]?.symbol;
	const title = `${titleText} (${currencySign})`;

	return (
		<>
			<div className="rate-header" title={title}>
				{title}
			</div>
			<div className="rate-data-wrapper">
				<Select
					data-test-id="rate-base-select"
					disabled={disabled || !onRateBaseChange}
					value={rateBase}
					options={rateBaseOptions}
					onChange={onRateBaseChange}
					getPopupContainer={getPopupContainer}
				/>
				<span className="rate-value-relation-sign">{rateBase === RateCardRateBase.Flat ? '=' : 'X'}</span>
				<InputNumber
					data-test-id="rate-value-input"
					disabled={disabled}
					value={rateValue}
					onChange={v => onRateValueChange(Number(v))}
					precision={rateBase === RateCardRateBase.Flat ? DEFAULT_PRECISION : undefined}
				/>
			</div>
		</>
	);
};
